// extracted by mini-css-extract-plugin
module.exports = {"body":"layout_body__eCm50","main":"layout_main__AVFoM"};